import React, { Component, PropTypes } from 'react';
import { Styles, CircularProgress } from 'material-ui';

const { Spacing } = Styles;

const styles = {
  container: {
    textAlign: 'center',
    paddingTop: Spacing.desktopGutterMini
  }
};

export default class Loader extends Component {
  static displayName = 'Loader';

  render() {
    return (
      <div style={styles.container}>
        <CircularProgress mode="indeterminate" />
      </div>
    );
  }
}

export { Loader };



// WEBPACK FOOTER //
// ./src/js/components/Material/Loader.js